<script setup lang="ts">
  import { unrefElement } from "@vueuse/core"
  import { onMounted, ref } from "vue"
  import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
  } from "@/components/ui/card/index.ts"
  import Progress from "@/components/ui/progress/Progress.vue"

  const props = defineProps<{
    title: string
    progress: number
    hideProgress?: boolean
    focusOnMount?: boolean
  }>()

  const titleRef = ref<InstanceType<typeof CardTitle>>()

  onMounted(() => {
    if (props.focusOnMount) unrefElement(titleRef)?.focus()
  })
</script>

<template>
  <div
    class="relative flex w-full max-w-3xl justify-center overflow-hidden rounded"
  >
    <Progress
      v-if="!hideProgress"
      class="absolute"
      data-testid="progress-indicator"
      :model-value="progress"
    />
    <Card class="w-full">
      <CardHeader>
        <div
          class="flex flex-row items-baseline justify-between gap-4 sm:gap-6"
        >
          <CardTitle ref="titleRef" :tabindex="focusOnMount ? -1 : undefined">
            {{ title }}
          </CardTitle>
          <span class="h4 text-nowrap">
            <slot name="supporting_title" />
          </span>
        </div>
      </CardHeader>
      <CardContent class="py-6 sm:pb-4 sm:pt-8">
        <slot />
      </CardContent>
      <CardFooter v-if="$slots.footer">
        <slot name="footer" />
      </CardFooter>
    </Card>
  </div>
</template>

<style scoped>
  :deep(p:not([class*="text-"])) {
    @apply text-secondary-500;
  }
</style>
